// rev: client-side-filter-reconcile-2026-05-20
(function(){
  // Section id is provided by the section's wrapper element (Liquid not available in assets).
  var rootSection = document.querySelector('.s2x[data-section-id]');
  var sid = rootSection ? rootSection.getAttribute('data-section-id') : '';
  if (!sid) return;

  // Mobile: #s2x-filter-btn toggles .s2x-side.is-open as bottom sheet
  var mobBtn = document.getElementById('s2x-filter-btn-' + sid);
  var sideEl = document.querySelector('.s2x-side');
  function openMobSide(){ if (!sideEl) return; sideEl.classList.add('is-open'); document.body.style.overflow='hidden'; if (mobBtn) mobBtn.setAttribute('aria-expanded','true'); }
  function closeMobSide(){ if (!sideEl) return; sideEl.classList.remove('is-open'); document.body.style.overflow=''; if (mobBtn) mobBtn.setAttribute('aria-expanded','false'); }
  if (mobBtn) mobBtn.addEventListener('click', function(){ sideEl && sideEl.classList.contains('is-open') ? closeMobSide() : openMobSide(); });
  document.addEventListener('click', function(e){
    if (!sideEl || !sideEl.classList.contains('is-open')) return;
    // Luk på ×, på baggrunden, og på "Vis N produkter"
    if (e.target.closest('.s2x-side__close') ||
        e.target.closest('[data-s2x-apply]') ||
        e.target.matches('.s2x-side__bg')) {
      e.preventDefault();
      closeMobSide();
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && sideEl && sideEl.classList.contains('is-open')) closeMobSide();
  });

  // ── AJAX filter submit (Shopify Section Rendering API) ──
  var rootForm = document.getElementById('s2x-root-form-' + sid);
  var mainEl = document.querySelector('[data-s2x-main]');
  var currentAbort = null;
  var reqSeq = 0;

  function buildFilterUrl(){
    if (!rootForm) return window.location.href;
    var fd = new FormData(rootForm);
    var params = new URLSearchParams();
    // Et afkrydset filter kan optræde både som checkbox og som skjult input,
    // hvilket ellers giver ?filter...=X&filter...=X. Tag hvert navn+værdi én gang.
    var seen = {};
    fd.forEach(function(val, key){
      if (val === '' || key === '') return;
      var k = key + ' ' + val;
      if (seen[k]) return;
      seen[k] = true;
      params.append(key, val);
    });
    var qs = params.toString();
    var base = rootForm.getAttribute('action') || window.location.pathname;
    return qs ? (base + '?' + qs) : base;
  }

  function ajaxSubmit(overrideUrl){
    if (!mainEl) mainEl = document.querySelector('[data-s2x-main]');
    if (!mainEl) return;
    var url = overrideUrl || buildFilterUrl();
    try { history.pushState({ s2x: true }, '', url); } catch (_) {}

    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid);
    if (currentAbort) currentAbort.abort();
    currentAbort = new AbortController();
    var mySeq = ++reqSeq;
    mainEl.classList.add('is-loading');

    fetch(fetchUrl, { signal: currentAbort.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r){ return r.ok ? r.text() : Promise.reject(r); })
      .then(function(html){
        if (mySeq !== reqSeq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Swap product grid
        swapNode(doc, '[data-s2x-main]');
        mainEl = document.querySelector('[data-s2x-main]');
        // Swap sidebar body so server-side counts/options update
        swapSidebarBody(doc);
        // Hold "Vis N produkter" i bunden af mobil-arket opdateret
        syncApplyCount(doc);
        // Then reconcile active states from the CURRENT URL — this is the source of truth
        // for multi-select state, regardless of how Shopify's Section Rendering API
        // interpreted the path context.
        reconcileSidebarActiveFromUrl();
        if (mainEl) mainEl.classList.remove('is-loading');
      })
      .catch(function(err){
        if (err && err.name === 'AbortError') return;
        if (mainEl) mainEl.classList.remove('is-loading');
        console.warn('[s2x] filter fetch failed', err);
      });
  }

  function swapNode(newDoc, selector){
    var oldEl = document.querySelector(selector);
    var newEl = newDoc.querySelector(selector);
    if (oldEl && newEl) oldEl.replaceWith(newEl);
  }

  // Antallet i "Vis N produkter" ligger uden for det swappede område,
  // så det skal opdateres manuelt fra det hentede dokument.
  function syncApplyCount(newDoc){
    var target = document.querySelector('[data-s2x-apply-count]');
    if (!target) return;
    var fresh = newDoc.querySelector('[data-s2x-apply-count]')
             || newDoc.querySelector('.s2x-top__count b');
    if (fresh) target.textContent = fresh.textContent.trim();
  }

  function swapSidebarBody(newDoc){
    var oldSide = document.querySelector('[data-s2x-side] .s2x-side__body');
    var newSide = newDoc.querySelector('[data-s2x-side] .s2x-side__body');
    if (!oldSide || !newSide) return;
    // Remember which <details> are open so we don't collapse them on re-render
    var openSet = {};
    oldSide.querySelectorAll('details').forEach(function(d, i){
      if (d.open) openSet[i] = true;
    });
    oldSide.replaceWith(newSide);
    // Re-apply open state by index
    var allNew = document.querySelectorAll('[data-s2x-side] .s2x-side__body details');
    allNew.forEach(function(d, i){ d.open = openSet[i] !== undefined ? openSet[i] : d.open; });
  }

  // Read tags from window.location.pathname and mark/unmark each filter link
  // in the sidebar. Authoritative source of truth for multi-select visual state.
  function reconcileSidebarActiveFromUrl(){
    var path = window.location.pathname;
    var parts = path.split('/').filter(Boolean);
    var currentTags = parts.length > 2 && parts[0] === 'collections'
      ? decodeURIComponent(parts.slice(2).join('/')).split('+').filter(Boolean)
      : [];
    // Map tag → true for O(1) lookup
    var tagSet = {};
    currentTags.forEach(function(t){ tagSet[t] = true; });

    var groups = document.querySelectorAll('[data-s2x-side] .s2x-fg');
    groups.forEach(function(group){
      var activeCount = 0;
      group.querySelectorAll('[data-s2x-tag-link]').forEach(function(link){
        var tag = link.getAttribute('data-s2x-tag');
        if (!tag) return;
        var isActive = !!tagSet[tag];
        link.classList.toggle('is-active', isActive);
        link.setAttribute('data-s2x-active', isActive ? '1' : '0');
        if (isActive) activeCount++;
      });
      // Update the per-group active counter badge (em.s2x-fg__n)
      var head = group.querySelector('.s2x-fg__head');
      if (head) {
        var existing = head.querySelector('.s2x-fg__n');
        if (activeCount > 0) {
          if (existing) {
            existing.textContent = activeCount;
          } else {
            var n = document.createElement('em');
            n.className = 's2x-fg__n';
            n.textContent = activeCount;
            // Insert before the chevron svg
            var car = head.querySelector('.s2x-fg__car');
            if (car) head.insertBefore(n, car);
            else head.appendChild(n);
          }
        } else if (existing) {
          existing.remove();
        }
      }
    });
  }

  document.addEventListener('click', function(e){
    var remove = e.target.closest && e.target.closest('[data-s2x-remove]');
    if (remove) {
      e.preventDefault();
      var rname = remove.getAttribute('data-param');
      var rval = remove.getAttribute('data-value');
      var rname2 = remove.getAttribute('data-param2');
      if (rootForm) {
        if (rval) {
          var ex = rootForm.querySelector('input[name="' + CSS.escape(rname) + '"][value="' + CSS.escape(rval) + '"]');
          if (ex) ex.remove();
        } else if (rname) {
          rootForm.querySelectorAll('input[name="' + CSS.escape(rname) + '"]').forEach(function(n){ n.remove(); });
          if (rname2) rootForm.querySelectorAll('input[name="' + CSS.escape(rname2) + '"]').forEach(function(n){ n.remove(); });
        }
      }
      ajaxSubmit();
      return;
    }
    var submitLink = e.target.closest && e.target.closest('[data-s2x-submit]');
    if (submitLink && submitLink.tagName === 'A') {
      e.preventDefault();
      ajaxSubmit(submitLink.href);
      return;
    }
    // Path-based tag filter link (multi-tag URL like /collections/dyner/a+b)
    // Compute the new URL CLIENT-SIDE from the current URL + clicked tag.
    // This way multi-select always works even if the server-rendered hrefs
    // in the sidebar are stale (e.g., before the AJAX swap completes).
    var tagLink = e.target.closest && e.target.closest('[data-s2x-tag-link]');
    if (tagLink && tagLink.tagName === 'A') {
      e.preventDefault();
      var clickedTag = tagLink.getAttribute('data-s2x-tag');
      var wasActive = tagLink.getAttribute('data-s2x-active') === '1';
      var newUrl = buildTagFilterUrl(clickedTag, wasActive);
      if (newUrl) {
        // Optimistic UI: toggle the visual active state immediately so user gets instant feedback
        tagLink.classList.toggle('is-active');
        tagLink.setAttribute('data-s2x-active', wasActive ? '0' : '1');
        ajaxSubmit(newUrl);
      } else {
        // Fallback: use the server-rendered href
        ajaxSubmit(tagLink.getAttribute('href'));
      }
      return;
    }
  });

  // Build a /collections/{handle}/{tag1+tag2} URL from current URL + clicked tag.
  // If wasActive, REMOVES the clicked tag. Else ADDS it.
  function buildTagFilterUrl(clickedTag, wasActive){
    if (!clickedTag) return null;
    var path = window.location.pathname;
    var parts = path.split('/').filter(Boolean); // e.g., ['collections', 'dyner', 'lun-helars']
    if (parts.length < 2 || parts[0] !== 'collections') return null;
    var handle = parts[1];
    var currentTags = parts.length > 2
      ? decodeURIComponent(parts.slice(2).join('/')).split('+').filter(Boolean)
      : [];
    var newTags;
    if (wasActive) {
      newTags = currentTags.filter(function(t){ return t !== clickedTag; });
    } else {
      newTags = currentTags.indexOf(clickedTag) === -1
        ? currentTags.concat([clickedTag])
        : currentTags;
    }
    var search = window.location.search || '';
    if (newTags.length === 0) {
      return '/collections/' + handle + search;
    }
    return '/collections/' + handle + '/' + newTags.join('+') + search;
  }

  // Sort <select> in the top bar → update hidden input and AJAX
  document.addEventListener('change', function(e){
    if (!e.target.matches('[data-s2x-select-sort]')) return;
    var sortIn = document.querySelector('[data-s2x-sort-input]');
    if (sortIn) sortIn.value = e.target.value;
    ajaxSubmit();
  });

  document.addEventListener('change', function(e){
    if (!(e.target.matches && e.target.matches('[data-s2x-submit]'))) return;
    if (e.target.type === 'checkbox') {
      var tname = e.target.name, tval = e.target.value;
      var existing = rootForm ? rootForm.querySelector('input[type=hidden][name="' + CSS.escape(tname) + '"][value="' + CSS.escape(tval) + '"]') : null;
      if (e.target.checked && !existing && rootForm) {
        var inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = tname; inp.value = tval;
        rootForm.appendChild(inp);
      } else if (!e.target.checked && existing) {
        existing.remove();
      }
    } else if (e.target.type === 'number') {
      clearTimeout(e.target.__t);
      var el = e.target;
      el.__t = setTimeout(function(){
        if (!rootForm) return;
        var n = el.name, v = el.value;
        rootForm.querySelectorAll('input[type=hidden][name="' + CSS.escape(n) + '"]').forEach(function(x){ x.remove(); });
        if (v !== '' && rootForm) {
          var hid = document.createElement('input');
          hid.type = 'hidden'; hid.name = n; hid.value = v;
          rootForm.appendChild(hid);
        }
        ajaxSubmit();
      }, 600);
      return;
    }
    ajaxSubmit();
  });

  window.addEventListener('popstate', function(e){
    if (e.state && e.state.s2x) ajaxSubmit(window.location.pathname + window.location.search);
  });

  // Quick-add: POST variant to /cart/add.js on button click inside card
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-s2x-qadd]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!vid) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(function(){
        btn.classList.add('is-done');
        btn.disabled = false;
        if (window.Shopify && window.Shopify.onCartUpdate) window.Shopify.onCartUpdate();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function(){ btn.classList.remove('is-done'); }, 1600);
      })
      .catch(function(){ btn.disabled = false; });
  });
})();

// SEO description: show "Læs mere" toggle only if content is taller than the clamp,
// then expand/collapse on click.
(function(){
  var body = document.querySelector('[data-s2x-seo-body]');
  var btn = document.querySelector('[data-s2x-seo-toggle]');
  if (!body || !btn) return;
  function checkOverflow(){
    var overflow = body.scrollHeight > body.clientHeight + 2;
    btn.hidden = !overflow;
  }
  // Run multiple times — defer scripts can fire before external CSS finishes loading,
  // so first checkOverflow() may see uncomputed/wrong heights.
  checkOverflow();
  requestAnimationFrame(checkOverflow);
  if (document.readyState !== 'complete') window.addEventListener('load', checkOverflow);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkOverflow);
  window.addEventListener('resize', checkOverflow, { passive: true });
  btn.addEventListener('click', function(){
    var open = body.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.querySelector('.s2x-seo__toggle-more').hidden = open;
    btn.querySelector('.s2x-seo__toggle-less').hidden = !open;
  });
})();
// rev
// rev2
// rev3
